import  axios from "axios";
import { getVideosFromPlaylists } from './getVideosFromPlaylists'
import configData from '../config.json'

const brand = ((configData.BRAND).toUpperCase()).replace(/\s/g, '');

// export function toNormalForm(str) {
//   return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
// }

export function toNormalForm(str) {
  var replacesCharactedString = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  var replaceDj = replacesCharactedString.replace(/Đ/g, 'Dj');
  var replacedj = replaceDj.replace(/ð|ď|đ/g, 'dj');

  var result = replacedj;

  return result
}


export async function getAllPlaylists() {

    var playlists = [];
    var playlistsStyleClasses = [ "d-blue",
                                  "d-yellow-deep", 
                                  "d-turquise", 
                                  "d-pink-deep", 
                                  "d-green-deep", 
                                  "d-red-deep", 
                                  "d-violet"
                                ];
    var counterClass;

    const url = "https://api.jwplayer.com/v2/sites/WVnFBBXI/playlists/?page=1&page_length=50&sort=last_modified:dsc";
    return axios.get(url, {
      headers: {
        accept: 'application/json',
        Authorization: 'Bearer osPoc-N8qOzyP6kMwJtUlGInUlhkVWEzcFVWamRNUVc5MlduRjNiMnBXV1hOaFFrZGon'
      }
    }).then((response) => {
  
      counterClass = 0;
      response.data.playlists.forEach(playlist => {

        if(playlist.metadata.custom_params.Brand){

          if(counterClass > 6) {
            counterClass = 0;
          }
          
          var brandCustomParamUpperCase = ((playlist.metadata.custom_params.Brand).toUpperCase()).replace(/\s/g, '');

          if(brandCustomParamUpperCase.includes(brand)) {
    
            var flatUrlName = toNormalForm(playlist.metadata.title);
            playlists.push({id: playlist.id, name: playlist.metadata.title, description: '', videos: [], styleClass: playlistsStyleClasses[counterClass], flatName: flatUrlName});
          }
          counterClass++;
        }
      });
      localStorage.setItem(configData.LOCALSTORAGE.PLAYLISTS, JSON.stringify(playlists));
      localStorage.setItem(configData.LOCALSTORAGE.PLAYLISTS_TIMESTAMP, Date.now());
  
      
});
}

export async function addVideosinPLaylists(playlists, setActiveCategory, setActiveVideo, setCategoryList) {
  
  var promises = [];
      playlists.map(playlist => {
        promises.push(getVideosFromPlaylists(playlists, "https://cdn.jwplayer.com/v2/playlists/" + playlist.id + '?page_limit=50'));
      });
  
      try {
        Promise.all(promises).then(() => {
                                  localStorage.setItem(configData.LOCALSTORAGE.CATEGORIES, JSON.stringify(playlists));
                                  localStorage.setItem(configData.LOCALSTORAGE.ACTIVE_CATEGORY, JSON.stringify(playlists[0]));
                                  localStorage.setItem(configData.LOCALSTORAGE.ACTIVE_VIDEO, JSON.stringify(playlists[0].videos[0]));

                                  setCategoryList(playlists);
                                  setActiveCategory(playlists[0]);
                                  setActiveVideo(playlists[0].videos[0]);
                        });    
      } catch (error) {
        console.error(error);
      }
}

export async function getMediaAdditionalParameters(mediaId) {

  const url = "https://api.jwplayer.com/v2/sites/WVnFBBXI/media/" + mediaId;
  return axios.get(url, {
    headers: {
      accept: 'application/json',
      Authorization: 'Bearer osPoc-N8qOzyP6kMwJtUlGInUlhkVWEzcFVWamRNUVc5MlduRjNiMnBXV1hOaFFrZGon'
    }
  }).then((response) => {

    var activeVideoMetadata = {id: response.data.id, author: response.data.metadata.author, permalink: response.data.metadata.permalink, tags: response.data.metadata.tags};
    localStorage.setItem("activeVideoAdditionalMetadata", JSON.stringify(activeVideoMetadata));
});
}